export const GET_FAQ_DATA = 'GET_FAQ_DATA';
export const FAQ_DATA_LOADED = 'FAQ_DATA_LOADED';